export default __webpack_public_path__ + "static/media/startpo.97cf4c7a.svg";